import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=57cf8e0d&scoped=true"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=57cf8e0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cf8e0d",
  null
  
)

export default component.exports
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QSpinner});
